import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import Container from '../container';
import Button from '../button';

const FloaterInner = styled.div`
  display: flex;
  gap: 1rem;
  > * {
    flex-grow: 1;
  }
`;

const AddMarginBottomToBodyForFloater = createGlobalStyle`
  body {
    margin-bottom: 4.5rem;
    @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
      margin-bottom: 0;
    }
  }
`;

const Floater = ({ className, children }) => (
  <div className={className}>
    <AddMarginBottomToBodyForFloater />
    <Container>
      <FloaterInner>
        {children}
      </FloaterInner>
    </Container>
  </div>
);

export default styled(Floater)`
  transition: .2s;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3;
  background-color: ${({ theme }) => theme.backgroundColor};
  border-top: 1px solid ${({ theme }) => theme.gray02};
  padding: .75rem 0;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
    display: none;
  }

  ${Button} {
    margin-top: 0;
  }
`;
